module.exports = __webpack_public_path__ + "img/7-1.0ac6db41.png";